/**
 * LUNEMUR — Favoris (V1, localStorage).
 * Vanilla JS, aucune dépendance, aucun appel réseau. Persiste sur l'appareil du
 * client (survit au rechargement de la page) via localStorage. Architecture
 * volontairement simple pour permettre plus tard une migration vers une
 * wishlist liée au compte client (même événements, même forme de données),
 * sans avoir à retoucher les boutons déjà en place sur les fiches produits.
 * Ne touche à aucun script Print Wallpaper Pro ni à aucune donnée de panier.
 */
window.LunemurWishlist = (function () {
  'use strict';

  var STORAGE_KEY = 'lunemur_wishlist_v1';
  var EVENT_NAME = 'lunemur:wishlist:change';

  function readAll() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeAll(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* stockage indisponible (navigation privée, quota) : on abandonne silencieusement */
    }
  }

  function has(id) {
    id = String(id);
    return readAll().some(function (item) { return item.id === id; });
  }

  function list() {
    return readAll();
  }

  function count() {
    return readAll().length;
  }

  function emit() {
    var items = readAll();
    try {
      window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { count: items.length, items: items } }));
    } catch (e) {
      /* CustomEvent indisponible sur de très vieux navigateurs : dégradation silencieuse */
    }
  }

  function add(entry) {
    if (!entry || !entry.id) return;
    var items = readAll();
    var id = String(entry.id);
    if (items.some(function (item) { return item.id === id; })) return;
    items.push({
      id: id,
      title: entry.title || '',
      url: entry.url || '#',
      image: entry.image || '',
      addedAt: Date.now()
    });
    writeAll(items);
    emit();
  }

  function remove(id) {
    id = String(id);
    var items = readAll().filter(function (item) { return item.id !== id; });
    writeAll(items);
    emit();
  }

  function toggle(entry) {
    if (!entry || !entry.id) return false;
    if (has(entry.id)) {
      remove(entry.id);
      return false;
    }
    add(entry);
    return true;
  }

  function syncButton(button) {
    var id = button.getAttribute('data-product-id');
    if (!id) return;
    var active = has(id);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    var mark = button.querySelector('[data-lm-wishlist-mark]') || button.querySelector('span');
    if (mark) mark.textContent = active ? '♥' : '♡';
  }

  function syncAllButtons() {
    document.querySelectorAll('[data-lm-wishlist-toggle]').forEach(syncButton);
  }

  function init() {
    syncAllButtons();

    document.addEventListener('click', function (e) {
      var button = e.target.closest('[data-lm-wishlist-toggle]');
      if (!button) return;
      e.preventDefault();
      var entry = {
        id: button.getAttribute('data-product-id'),
        title: button.getAttribute('data-product-title'),
        url: button.getAttribute('data-product-url'),
        image: button.getAttribute('data-product-image')
      };
      toggle(entry);
      document.querySelectorAll('[data-lm-wishlist-toggle][data-product-id="' + entry.id + '"]').forEach(syncButton);
    });

    window.addEventListener(EVENT_NAME, syncAllButtons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { has: has, list: list, count: count, add: add, remove: remove, toggle: toggle, EVENT_NAME: EVENT_NAME };
})();
